import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CorporateService } from './services/corporate.service';
import { RouterModule } from '@angular/router'
import { AgenqWidgetComponent } from './agenq-widget/agenq-widget.component';
import { environment } from './environments/environment'
import { ScriptLoaderService } from './services/script-loader.service';

@Component({
  selector: 'app-root',
//   standalone: true,
//  imports: [
//  RouterModule, // Required for routing
//  AgenqWidgetComponent // AGENQ Widget Component
//  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {

  constructor(public _router: Router, private route: ActivatedRoute,private _CorporateService: CorporateService,
    private scriptLoader: ScriptLoaderService
  ){

  }

  ngAfterViewInit(): void {
    // Target the inner .header div (position:fixed block element) — the
    // <app-header> custom element itself is display:inline and gives wrong offsetHeight.
    const sync = () => {
      const headerEl = document.querySelector('.header') as HTMLElement | null;
      if (headerEl) {
        document.documentElement.style.setProperty('--header-height', headerEl.offsetHeight + 'px');
      }
    };

    sync(); // initial measurement (before images load)

    // Re-measure once all images/resources finish loading
    window.addEventListener('load', sync, { once: true });

    // Re-measure on every image load inside the header (async logo loads)
    setTimeout(() => {
      const headerEl = document.querySelector('.header') as HTMLElement | null;
      if (headerEl) {
        headerEl.querySelectorAll('img').forEach(img => {
          if (!img.complete) {
            img.addEventListener('load', sync, { once: true });
          }
        });
        new ResizeObserver(sync).observe(headerEl);
      }
    }, 0);
  }
  showAgenq: boolean = false;  //flag to control voice agent
  title = 'gb';
  environment = environment;
  overrideSessionStorageSetItem() {
    const originalSetItem = sessionStorage.setItem;
    sessionStorage.setItem = (key: string, value: string) => {
      originalSetItem.call(sessionStorage, key, value);

      // get agent container
      let agentContainer: any = document.getElementById('agent-container');
      if (
        key === "enableCloey"
      ) {
        this.showAgenq = sessionStorage.getItem("enableCloey") == "true" ? true : false;

        // enable agent-container on condition
        console.log('this.showAgenq', this.showAgenq)
        if(this.showAgenq){
          console.log('agentContainer true', agentContainer)
          agentContainer.style.display = 'flex';
        }else{
          console.log('agentContainer false', agentContainer)
          agentContainer.style.display = 'none';
        }
 
      }
    };
  }
  ngOnInit(): void {
    this.scriptLoader.loadAuthorizeNetScript();
    this.overrideSessionStorageSetItem();
//   if (this.route.snapshot.params['formLink'] != undefined) {
//       this._CorporateService.getCorporateData(this.route.snapshot.params['formLink'], this.route.snapshot.params['employeeLink']).subscribe({
//         next: (result: any) => {
//           // //console.log(result);

//           if (result.status == "200") {



//           }
//           else {
//             alert("!")

// return false
//           }


//         },
//         error: (error:any) => {
//           if ([0, 500, 501, 502, 503].includes(error.status)) {



//           }
//           else {
//             return false
//           }
//         },
//       });
//     } else {
//     this._router.navigate(["error"]);

//     }

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // sessionStorage.setItem("language","English")
    if(sessionStorage.getItem("language")){

    }
    else{
      sessionStorage.setItem("language","English")
    }

    // this.loadAuthorizeNetScripts()
  }

  loadAuthorizeNetScripts() {
    const isTestEnv = !environment.app.production;

    const script1 = document.createElement('script');
    script1.src = isTestEnv
      ? 'https://jstest.authorize.net/v1/Accept.js'
      : 'https://js.authorize.net/v1/Accept.js'; // production

    const script2 = document.createElement('script');
    script2.src = 'https://api.authorize.net/xml/v1/request.api';

    script1.type = script2.type = 'text/javascript';
    script1.async = script2.async = false;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }

  }
